<template>
    <v-menu v-model="openList" offset-y :transition="transition">
        <template v-slot:activator="{}">
            <v-btn v-haptic :color="isDark ? color : 'text'" :icon="icon" :block="block" :class="{'surface2': !text && !icon}" :large="large" :text="!icon" :outlined="!icon" @click="openAction" >
                <v-row v-if="!icon">
                    <v-col cols="5" class="d-flex justify-end align-center px-1">
                        <v-icon :color="active ? 'secondary' : undefined" class="me-3" :size="large ? 25 : 21" left>{{currentIcon}}</v-icon>
                    </v-col>
                    <v-col cols="7" class="d-flex justify-start align-center px-1">
                        <span v-if="!icon">{{currentTheme}}</span>
                        <v-icon v v-if="dropdownIcon" right>mdi-menu-down</v-icon>
                    </v-col>
                </v-row>
                <v-icon :color="active ? 'secondary' : undefined" size="25" v-else>{{currentIcon}}</v-icon>

            </v-btn>
        </template>
        <v-list color="surface2">
            <v-list-item v-for="(theme, index) in themes" :key="index" @click="changeTheme(theme.value)" >
                <v-list-item-title>{{ theme.text }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import Colors from '@/helpers/colors'

export default {
    props: {
        large: {
            type: Boolean,
            default: true,
        },
        text: {
            type: Boolean,
            default: false,
        },
        dropdownIcon: {
            type: Boolean,
            default: false,
        },
        color: {
            default: 'primary',
        },
        block: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: Boolean,
            default: false,
        },
        transition: {
            default: 'slide-y-transition' // 'slide-y-transition'
        },
        showList: {
            type: Boolean,
            default: true,
        },
    },
    data(){
        return {
            openList: false,
            themes: [
                {value: 'light', text: 'light'},
                {value: 'dark', text: 'dark'},
            ]
        }
    },
    computed: {
        currentIcon(){
            // return this.current === 'dark' ? 'mdi-brightness-4' : 'mdi-brightness-7';
            // return this.current === 'light' || this.phoneOnly ? 'mdi-weather-night' : 'mdi-brightness-7';
            return'mdi-weather-night';
        },
        currentTheme(){
            let theme = this.themes.find(th=>th.value === this.current);
            return theme ? theme.text : '';
        },
        current(){
            return this.$vuetify.theme.dark ? 'dark' : 'light';
        },
        active(){
            return this.current === 'dark';
        },
        ...GlobalComputed
    },
    watch:{
        current(theme){
            return this.changeTheme(theme, true);
        },
    },
    methods: {
        openAction(){
            if(this.showList){
                this.openList = !this.openList;
            }else{
                let theme = this.current === 'dark' ? 'light' : 'dark';
                this.changeTheme(theme);
            }
        },
        changeTheme(theme, force=false){
            if (theme !== this.current || force){
                this.$vuetify.theme.dark = theme === 'dark' ? true : false;
                this.setSavedTheme(theme);
                this.setHtmlThemeClass(theme);
            }
        },
        setHtmlThemeClass(theme){
            window.document.querySelector('html').classList.remove('theme--light');
            window.document.querySelector('html').classList.remove('theme--dark');
            window.document.querySelector('html').classList.add(`theme--${theme}`);
            let themeColor = theme === 'dark' ? '#000000' : Colors.primary;
            window.document.querySelector('meta[name="theme-color"]').setAttribute('content', themeColor);
        },
        setSavedTheme(theme){
            window.localStorage.setItem('theme', theme);
        },
        checkTheme(theme){
            return this.themes.some(th=>th.value === theme);
        },
        ...GlobalMethods
    },
    created(){

        let savedTheme = window.localStorage.getItem('theme');
        if (savedTheme && this.checkTheme(savedTheme) && this.isAuthed){
            if (this.current !== savedTheme){
                this.changeTheme(savedTheme);
            }else{
                this.setHtmlThemeClass(savedTheme);
            }
        }else{
            // first time
            let theme = process.env.VUE_APP_DEFAULT_THEME;
            this.setSavedTheme(theme);
            this.changeTheme(theme);
        }
    }
}
</script>


